// 亚美尼亚语
// Armenian
const hy = {
  common: {
    notSupport: 'Ձեր բրաուզերը չի աջակցում լրիվ էկրանով ռեժիմին',
    loadFail: 'Թեմայի բեռնման ձախողում',
    noPermission: 'Ներեցեք, դուք թույլտվություն չունեք մուտք գործել էջ',
    backHome: 'Վերադառնալ գլխավոր էջ',
    noExit: 'Էջը, որ փորձում եք մուտք գործել, գոյություն չունի',
    serverError: 'Սերվերը սխալ է արձանագրել',
    slide: 'Ձախ սահեցրեք',
    veryHigh: 'Շատ Բարձր',
    high: 'Բարձր',
    target: 'Թիրախ',
    urgentLow: 'Շատ Ցածր',
    agpNoData: 'AGP հաշվետվության համար անհրաժեշտ է առնվազն 5 օրվա տվյալ',
    noDataStr: 'Տվյալներ չկան',
    setting: 'Կարգավորումներ',
    personInfo: 'Հիմնական տեղեկատվություն',
    updatePwd: 'Փոխել գաղտնաբառը',
    upHead: 'Ներբեռնել նկարներ',
    inRange: 'Տիրույթում',
    normal: 'Նորմալ',
    low: 'Ցածր',
    previous: 'Նախորդ',
    next: 'Հաջորդ',
    search: 'Որոնում',
    reset: 'Վերակայել',
    cancel: 'Չեղարկել',
    ok: 'Լավ',
    confirm: 'Հաստատել',
    save: 'Պահպանել',
    submit: 'Ուղարկել',
    successful: 'Հաջողված է',
    pleaseEnter: 'Խնդրում ենք մուտքագրել',
    pleaseSelect: 'Խնդրում ենք ընտրել',
    success: 'Հաջողված է',
    confirmLogout: 'Վստա՞հ եք, որ ցանկանում եք դուրս գալ',
    updateSuccessed: 'Թարմացումը հաջողությամբ ավարտվեց',
    warning: 'Զգուշացում',
    date: 'Ամսաթիվ',
    start: 'Սկիզբ',
    end: 'Ավարտ',
    sevenDays: '7 օր',
    fourteenDays: '14 օր',
    thirtyDays: '30 օր',
    signOut: 'Դուրս գալ',
    personalInformation: 'Հիմնական տեղեկատվություն',
    email: 'Էլ. փոստ',
    name: 'Անուն',
    mobile: 'Բջջային',
    dateOfBirth: 'Ծննդյան ամսաթիվ',
    gender: 'Սեռ',
    diabeteType: 'Շաքարային դիաբետի տեսակ',
    dateOfDignose: 'Հիվանդության ախտորոշման տարի',
    remarks: 'Նշումներ',
    optionMale: 'Արական',
    optionFemale: 'Իգական',
    optionUnknow: 'Չեմ ցանկանում նշել',
    noDiabetes: 'Չկա դիաբետ',
    diabeteTypeI: 'Տիպ I',
    diabeteTypeII: 'Տիպ II',
    diabeteSpecial: 'Հատուկ',
    diabeteGestational: 'Գեստացիոն դիաբետ',
    diabeteOthers: 'Այլ',
    ruleMsgEmail: 'Խնդրում ենք մուտքագրել էլ. փոստ',
    ruleMsgName: 'Խնդրում ենք մուտքագրել անուն',
    ruleMsgMobile: 'Խնդրում ենք մուտքագրել բջջային',
    ruleMsgBirthday: 'Խնդրում ենք ընտրել ծննդյան օր',
    ruleMsgSex: 'Խնդրում ենք ընտրել սեռ',
    ruleMsgDiabeteType: 'Խնդրում ենք ընտրել դիաբետի տեսակ',
    ruleMsgDateOfDignose: 'Խնդրում ենք ընտրել հիվանդության ախտորոշման տարի',
    ruleMsgRemarks: 'Խնդրում ենք մուտքագրել նշումներ',
    ruleMsgCorrectMobile: 'Խնդրում ենք մուտքագրել ճիշտ բջջային',
    oldPassword: 'Հին գաղտնաբառ',
    newPassword: 'Նոր գաղտնաբառ',
    confirmPassword: 'Հաստատել գաղտնաբառը',
    ruleMsgOldPassword: 'Խնդրում ենք մուտքագրել հին գաղտնաբառը',
    ruleMsgNewPassword: 'Խնդրում ենք մուտքագրել նոր գաղտնաբառը',
    ruleMsgConfirmPassword: 'Խնդրում ենք հաստատել գաղտնաբառը',
    passwordInconsistent: 'Երկու գաղտնաբառերի մուտքերը չեն համընկնում',
    passwordModifySuccessed:
      'Ձեր գաղտնաբառը վերականգնվել է, խնդրում ենք նորից մուտք գործել:',
    monday: 'Երկ',
    tuesday: 'Երք',
    wednesday: 'Չրք',
    thursday: 'Հնգ',
    friday: 'Ուրբ',
    saturday: 'Շբթ',
    sunday: 'Կիր',
    sn: 'Սերիական համարը',
    startDate: 'Սկիզբ ամսաթիվ',
    days: 'օր',
    pdfDate: 'Ընդհանուր նպատակը',
    close: 'Փակել',
    // inputTip: 'Խնդրում ենք մուտքագրել որոնվող բառեր',
    inputTip: 'Խնդրում ենք մուտ...',
    polarization: 'Սարքը նախապատրաստման մեջ է',
    hour: 'ժ',
    minutes: 'ր',
    seconds: 'վրկ',
    reportDownLoadTip: 'Ձեր հաշվետվությունը չի ստեղծվել 5 օր',
    age: 'տարիք',
    goal: 'Նպատակ',
    expired: 'Սենսորը սպառված է',
    lastTime: 'Վերջին թարմացման ժամանակը',
    timeZone: 'Ժամային գոտի'
  },
  route: {
    login: 'Մուտք',
    forget: 'Մոռացել եք գաղտնաբառը',
    home: 'Գլխավոր էջ',
    glucoseReport: 'Շաքարի հաշվետվություն',
    sessionReport: 'Սեանսի հաշվետվություն',
    eventList: 'Իրադարձությունների ցանկ',
    followerList: 'Հետևորդների ցուցակ',
    followerListQ: 'Դիտորդի հարցում',
    settings: 'Կարգավորումներ',
    profile: 'Պրոֆիլ'
  },
  login: {
    rememberMe: 'Հիշել ինձ',
    forgetPassword: 'Մոռացել եք գաղտնաբառը',
    agree: 'Մուտք գործելով Դուք համաձայնում եք FurCarer-ի հետ',
    privacyPolicy: 'Գաղտնիության քաղաքականություն',
    CGMUser: 'CGM օգտատեր',
    follower: 'Հետևորդ',
    ruleMsgPassword: 'Խնդրում ենք մուտքագրել գաղտնաբառ',
    login: 'Մուտք',
    phonePlacehold: 'Խնդրում ենք մուտքագրել հեռախոսահամար',
    codePlacehold: 'Խնդրում ենք մուտքագրել վավերացման կոդը',
    codePlaceholdInput: 'Խնդրում ենք մուտքագրել t...',
    phoneTip: 'Հեռախոսով',
    emialTip: 'Էլ. փոստով',
    codeTip: 'Ստանալ վավերացման կոդ',
    reGetTip: 'Նորից ստանալ'
  },
  layout: {
    collapseUp: 'Թաքցնել մենյուն',
    collapseDown: 'Բացել մենյուն',
    refresh: 'Թարմացնել',
    backHome: 'Գլխավոր էջ',
    helpCenter: 'Օգնության կենտրոն',
    fullScreen: 'Լրիվ էկրանով'
  },
  forget: {
    ruleMsgCode: 'Խնդրում ենք մուտքագրել կոդը',
    sendCode: 'Ուղարկել կոդ',
    tipsMsgSendSuccess: 'Վավերացման կոդը հաջողությամբ ուղարկվել է:',
    tipsMsgModifySuccess: 'Գաղտնաբառի փոփոխությունը հաջողվել է'
  },
  home: {
    title: 'FurCarer Portal',
    todaysGlucose: 'Շաքարի  տվյալներն այսօր',
    todaysOverview: 'Ընդհանուր պատկեր այսօր',
    maxGlucose: 'Ամենաբարձր շաքար',
    minGlucose: 'Ամենացածր շաքար',
    avgGlucose: 'Միջին շաքար',
    maxmumVariation: 'Ամենամեծ տատանում',
    glucose: 'Շաքար',
    tir: 'Տիրույթում',
    latestGlucose: 'Վերջին շաքար',
    todayPercentage: 'Օրվա տարբեր տիրույթներում%',
    fourHour: '4 ժամ',
    eightHour: '8 ժամ',
    twelveHour: '12 ժամ',
    twentyFourHour: '24 ժամ',
    glucoseOnly: 'Միայն շաքար',
    sessionOverview: 'Խաղընթացի ընդհանուր նկարագրություն',
    glocuseMetrics: 'Շաքարի չափումներ',
    agp: 'AGP',
    dailyGlucose: 'Օրվա շաքար',
    sessionGlucose: 'Սեանսի շաքար',
    standTir: 'Ստանդարտ TIR',
    customTir: 'Անհատականացված TIR',
    cancleGz: 'Չհետևել',
    cancleText: 'Դուք չե՞ք ցանկանու՞մ այլևս հետևել այս օգտատիրոջը:',
    helpCenterTip: 'Ֆունկցիան դեռ բացված չէ'
  },
  glucoseReport: {
    statics: 'Ստատիստիկա',
    sixHour: '6 ժամ TIR',
    avgGlucose: 'Միջին շաքար',
    maxGlucose: 'Ամենամեծ շաքար',
    minGlucose: 'Ամենափոքր շաքար',
    cv: 'CV',
    high: 'Բարձր արդյունքների քանակ',
    low: 'Ցածր արդյունքների քանակ',
    normal: 'Նորմալ արդյունքների քանակ',
    tir: 'Տիրույթում',
    estimatedA1c: 'Մոտավոր A1c',
    min: 'Ամենափոքր',
    avg: 'Միջին',
    max: 'Ամենամեծ',
    maxVariation: 'Ամենամեծ տատանում'
  },
  glucoseProfile: {
    avg: 'Միջին',
    sd: 'SD',
    cv: 'CV'
  },
  eventList: {
    all: 'Բոլորը',
    bg: 'Շաքար',
    meal: 'Ճաշ',
    sport: 'Մարզանք',
    insulin: 'Ինսուլին',
    alert: 'Զգուշացում',
    eventType: 'Իրադարձության տեսակ',
    description: 'Նկարագրություն',
    note: 'Նշում',
    highAlert: 'Զգուշացում զգուշացում',
    calibration: 'Կալիբրացիա',
    meds: 'Դեղեր',
    time: 'Ժամանակ',
    detail: 'Նկարագրություն',
    weigt: 'Քաշ'
  },
  followerList: {
    title: 'Հետևողներ',
    tabTitle: 'Հետևորդների կառավարում',
    refreshText:
      'Ավտոմատ թարմացում (օգտատերերի ցուցակը ավտոմատ թարմացվում է յուրաքանչյուր 30 վայրկյան)',
    addText: 'Ավելացնել',
    dataText: 'Ստացված տվյալներ',
    timeText: 'րոպե',
    hourText: 'ժամ',
    agoText: ' համար',
    tableEmail: 'Մուտքագրեք հաշվի համարը',
    // searchPlacehold: 'Խնդրում ենք մուտքագրել ձեր հաշվի համարը որոնման համար',
    searchPlacehold: 'Խնդրում ենք մուտքագրել ձեր հաշվ...',
    pending: 'Սպասման մեջ է',
    approved: 'Հաստատված է',
    rejected: 'Մերժված է',
    addFollower: 'Ավելացնել հետևորդ',
    editFollower: 'Խմբագրել հետևորդին',
    tableName: 'Անուն',
    tableAddTime: 'Ավելացման ժամանակ',
    tableStatus: 'Կարգավիճակ',
    tableApproved: 'Հաստատված է',
    tableReject: 'Մերժել',
    tableStartSharing: 'Սկսել տվյալների փոխանակումը',
    tableStopSharing: 'Դադարեցնել տվյալների փոխանակումը',
    op: 'Գործողություն',
    sharing: 'Փոխանակվում է',
    notSharing: 'Չի փոխանակվում',
    tableRemove: 'հեռացնել',
    note: 'Նշում',
    message: 'Հաղորդագրություն',
    ruleMsgEmailEmpty: 'Խնդրում ենք մուտքագրել էլ. հասցեն որոնման համար',
    ruleMsgNote: 'Խնդրում ենք մուտքագրել նշումը',
    ruleMsgMessage: 'Խնդրում ենք թողնել հաղորդագրություն',
    ruleMsgEmailCorrect: 'Խնդրում ենք մուտքագրել ճիշտ էլ. հասցե',
    formAcknowledge:
      'Ես հաստատում եմ, որ հետևորդ ավելացնելը թույլ կտա այս օգտատիրոջը տեսնել իմ տվյալները',
    sendFollowRequest: 'Ուղարկել հետևելու հարցումը',
    setNote: 'Նշում կատարել',
    tipsAcknowledge:
      'Խնդրում ենք նշել վանդակը, որով հաստատում եք, որ հետևորդ ավելացնելը թույլ կտա այս օգտատիրոջը տեսնել իմ տվյալները',
    stopSharing: 'Դադարեցնել փոխանակումը',
    startSharing: 'Սկսել փոխանակումը',
    removeUser: 'Հեռացնել օգտատիրոջը',
    confirmStopSharing:
      'Համոզվա՞ծ եք, որ ցանկանում եք դադարեցնել գլուկոզայի տվյալների փոխանակումը այս օգտատիրոջ հետ։',
    confirmStartSharing:
      'Համոզվա՞ծ եք, որ ցանկանում եք սկսել գլուկոզայի տվյալների փոխանակումը այս օգտատիրոջ հետ։',
    confirmRemove:
      'Համոզվա՞ծ եք, որ ցանկանում եք հեռացնել այս օգտատիրոջը ցուցակից։',
    approvedFollower: 'Հաստատված հետևորդ',
    rejectFollower: 'Մերժված հետևորդ',
    confirmApproved:
      'Համոզվա՞ծ եք, որ ցանկանում եք հաստատել այս հետևորդի հարցումը։',
    confirmReject:
      'Համոզվա՞ծ եք, որ ցանկանում եք մերժել այս հետևորդի հարցումը։',
    addTime: 'Ավելացման ժամանակ',
    check: 'Ստուգել',
    remove: 'Հեռացնել',
    removeUserTitle:
      'Համոզվա՞ծ եք, որ ցանկանում եք հեռացնել այս օգտատիրոջը ցուցակից։'
  },
  settings: {
    title: 'Գլուկոզայի մակարդակի կարգավորումներ',
    unitSet: 'Միավորի կարգավորում',
    targetSet: 'Անհատականացված TIR կարգավորում',
    alertSet: 'Զգուշացումների կարգավորում',
    highAlert: 'Բարձրի զգուշացում',
    lowAlert: 'Ցածր զգուշացում',
    urgentLow: 'Ծայրահեղ ցածր',
    urgentHigh: 'Ծայրահեղ բարձր',
    target: 'Թիրախ'
  },
  pdf: {
    dailyStatistics: 'Օրվա վիճակագրություն',
    title: 'AGP հաշվետվություն',
    page: 'Էջ',
    generated: 'Ստեղծված է',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Ժամանակի սահմաններում',
    timeInRange: 'Ժամանակի սահմաններում (TIR)',
    agpTitle: 'Ամբուլատոր գլուկոզայի պրոֆիլ (AGP)',
    agpSubTitle:
      'AGP-ն գլուկոզայի զեկույցների արժեքների ամփոփում է , միջին և այլ տոկոսներով ներկայացված, ասես դրանք չափվել են մեկ օրվա ընթացքում',
    dailyTitle: 'Օրվա շաքարի պրոֆիլ',
    dailySubTitle:
      'Յուրաքանչյուր օր ներկայացվում է կեսգիշերից կեսգիշեր ժամանակահատվածում։',
    device: 'Սարք',
    tDevice: 'Վերջնական սարք',
    print: 'Տպել',
    model: 'Մոդել',
    deviceSn: 'Սարքի սերիական համարը',
    effectiveData: 'Արդյունավետ տվյալներ',
    days: 'Օրեր',
    appVer: 'Հավելվածի տարբերակ',
    smartPhoneModel: 'Սմարթֆոնի մոդել',
    osVersion: 'OS տարբերակ',
    appSetting: 'Հավելվածի կարգավորումներ',
    GoalsforType1andType2Diabetes: '1 և 2 տիպի դիաբետի նպատակներ',
    Each1timeinrange15minutes:
      'Յուրաքանչյուր 1% ժամանակը սահմաններում ≈15 րոպե',
    note: 'Նշում. % միավորը կիրառվում է DCCT ստանդարտի համար, mmol/mol միավորը կիրառվում է IFCC ստանդարտի համար։',
    DOB: 'Ծննդյան ամսաթիվ',
    SN: 'SN'
  },
  field: {
    timeCgmActive: 'CGM-ի ակտիվ ժամանակը',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'eHbA1c',
    avgPerDay: 'Օրվա միջին կալիբրացիա',
    glucoseAbility: 'Գլուկոզայի տատանումներ',
    lage: 'Lage',
    mage: 'Mage',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Կալիբրացիաներ'
  },
  agp: {
    agpTitle: 'Ամբուլատոր գլուկոզայի պրոֆիլ (AGP)',
    centerLine: 'Միջնարժեք',
    areaLine: 'Միջակայք',
    target: 'Թիրախի միջակայք'
  },
  basic: {
    customTir: 'Անհատական TIR',
    bloodTip: 'Շաքարի հիշեցման կարգավորումներ',
    bloodUnit: 'Շաքարի միավոր',
    highTip: 'Բարձր գլուկոզայի զգուշացում',
    lowTip: 'Ցածր գլուկոզայի զգուշացում',
    unitText: 'Ավտոմատ սահմանվում է ըստ երկրի/տարածաշրջանի',
    selectTip:
      'Սեղմեք պատկերակի վրա՝ համապատասխան ամսաթիվը ընտրելու կամ հեռացնելու համար',
    selectAll: 'Ընտրել բոլորը'
  },
  report: {
    threeMonth: 'Վերջին 3 ամիս',
    sixMonth: 'Գրեթե 6 ամիս',
    yearText: 'Վերջին տարի',
    showAll: 'Ցուցադրել բոլորը',
    all: 'Բոլորը',
    selectDate: 'Ընտրել ամսաթվի միջակայք',
    to: 'մինչև',
    startDt: 'Մեկնարկի ամսաթիվ',
    endDt: 'Ավարտի ամսաթիվ',
    betaTest: 'Բետա փորձարկում',
    bloodData: 'Շաքարի տվյալներ',
    userCount: 'Օգտատիրոջ հաշիվ'
  },
  petDetail: {
    variety: 'Ցեղատեսակ',
    type: 'Ինսուլինի տեսակ',
    freq: 'Ինսուլինի հաճախականություն',
    lente: 'Lente',
    insulin: 'Glargine',
    pzi: 'PZI',
    nph: 'NPH',
    detemir: 'Detemir'
  },
  pdfReport: {
    title: 'AGP հաշվետվություն',
    snNumber: 'Սերիական համար',
    page: 'Էջ',
    createTime: 'Ստեղծված է',
    petInfo: 'Իմ կենդանու տվյալները',
    petName: 'Կենդանու անունը',
    birthday: 'Ծննդյան ամսաթիվ',
    freq: 'Ինսուլինի հաճախականություն',
    petType: 'Կենդանու տեսակ',
    age: 'Տարիք',
    registerType: 'Ներարկիչի տեսակ',
    basicBloodData: 'Գլուկոզայի չափման ցուցանիշներ',
    dbText: 'Ժամանակը սահմաններում (TIR)',
    target: '1 և 2 տիպի դիաբետի նպատակներ',
    recordTime: 'Գրանցման ժամանակը',
    tag: 'Պիտակ',
    event: 'Իրադարձություն',
    eventDetail: 'Իրադարձության մանրամասներ',
    mulityText: 'Մի քանի օրվա շաքարի միտումների գրաֆիկ',
    mulitySubText:
      'Մի քանի օրվա շաքարի պրոֆիլները ներկայացնում են սարքի չափման միջակայքը',
    avageBlood: 'Միջին գլուկոզա',
    bloodText: 'MODD',
    highTip: 'Բարձր շաքարի ահազանգ',
    lowTip: 'Ցածր շաքարի ահազանգ',
    cat: 'Կատու',
    dog: 'Շուն',
    country: 'Երկիր',
    insulinDose: 'Ինսուլինի դեղաչափ',
    weightUnit: 'կգ'
  },
  eventDetail: {
  Empty: 'Նախաճաշ',
  After_Breakfast: 'Նախաճաշից հետո',
  Before_Lunch: 'Ճաշից առաջ',
  Breakfast: 'Նախաճաշ',
  Lunch: 'Ճաշ',
  Dinner: 'Ընթրիք',
  Before_Sleep: 'Քնելուց առաջ',
  Extra: 'Հավելյալ',
  Short_acting: 'Կարճ ազդեցության',
  Pre_mixed: 'Խառը',
  Long_acting: 'Երկար ազդեցության',
  Middle_acting: 'Միջին ազդեցության',
  hour: 'ժ',
  minutes: 'ր'
}
};
export default hy;
